// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatDisplayModeToggler_wrapper__1SkUh","active":"ChatDisplayModeToggler_active__iJNjg"};